var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"square","d":"M11.597 21.275L1.238 10.915 11.598.556"}));
}

BackArrow.defaultProps = {"viewBox":"0 0 13 22"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
